import { FONT_REGISTRY } from './font-registry';
import type { FontKey } from './types';

/**
 * Build a Google Fonts CSS API URL that loads every non-default font in
 * `fontKeys` in a single HTTP request.
 *
 * Returns `''` when there's nothing to load (only `atlassian-sans` picks,
 * or empty input).
 *
 * The output is a URL string intended to be used as the `href` of a
 * `<link rel="stylesheet">` element rendered by `<HubTypographyScope>`.
 * Pure and synchronous — safe to call during render, including SSR.
 */
export const buildGoogleFontsUrl = (fontKeys: FontKey[]): string => {
	const families = new Set<string>();
	for (const key of fontKeys) {
		const family = FONT_REGISTRY[key].googleFontsFamily;
		if (family) families.add(family);
	}
	if (families.size === 0) return '';
	const query = Array.from(families)
		.map((f) => `family=${f}`)
		.join('&');
	return `https://fonts.googleapis.com/css2?${query}&display=swap`;
};
